import { render, staticRenderFns } from "./KeywordWarningInfo.vue?vue&type=template&id=295a758b&"
import script from "./KeywordWarningInfo.vue?vue&type=script&lang=js&"
export * from "./KeywordWarningInfo.vue?vue&type=script&lang=js&"
import style0 from "./KeywordWarningInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports